import {Controller} from '@hotwired/stimulus';
import {application} from 'src';
import {find, findAll, addClass, removeClass, toggleClass} from '@fretadao/f-js-dom';
import './component.scss';

application.register(
  'collapsible-card',
  class extends Controller {
    static values = {
      behavior: {
        type: String,
        default: 'closed'
      }
    }

    connect(){
      if (this.#isOpened()) {
        this.toggleBody(this.element);
        this.invertIcon(this.element);
      }
    }

    toggle(e) {
      let card = e.currentTarget.parentElement;

      this.toggleBody(card);
      this.invertIcon(card);
      if (!this.#isOpened()) this.closeOtherCards(card);
    }

    toggleBody(card) {
      let cardBody = find(this.data.get('cardBodySelector'), card);
      toggleClass(cardBody, this.data.get('cardBodyHiddenClass'));
    }

    invertIcon(card) {
      let icon = find('i', card);
      toggleClass(icon, this.data.get('invertedIconClass'));
    }

    closeOtherCards(clickedCard) {
      let otherCards = findAll('.CollapsibleCard').filter(card => card != clickedCard);
      otherCards.forEach(card => {
        let cardBody = find(this.data.get('cardBodySelector'), card);
        addClass(cardBody, this.data.get('cardBodyHiddenClass'));
        let icon = find('i', card);
        removeClass(icon, this.data.get('invertedIconClass'));
      });
    }

    #isOpened() {
      return this.behaviorValue == 'opened';
    }
  }
);
